<template>
  <div
    class="modal fade colored-header colored-header-primary"
    id="mod-sales"
    role="dialog"
  >
    <div
      class="modal-dialog p-0 m-0 fixed top-0 right-0 flex justify-end items-end"
    >
      <div
        class="modal-content min-h-screen rounded-none bg-[#f8f8f8] p-[40px]"
      >
        <div
          class="modal-header modal-header-colored flex items-start justify-between p-0 m-0"
        >
          <h4
            class="font-semibold text-[20px] leading-[24px capitalize text-[#353535] pb-[16px]"
          >
            Invite new user
          </h4>
          <button
            class="text-2xl text-[#353535]"
            type="button"
            data-dismiss="modal"
            aria-hidden="true"
          >
            <span class="mdi mdi-close"></span>
          </button>
        </div>
        <div class="modal-body p-0 m-0">
          <div class="pb-[16px]">
            <label
              class="text=[#353535] font-bold-500 text-[14px] leading-[20px]"
              >Email address</label
            >
            <div>
              <input
                :class="[{ 'is-invalid': $v.invitedUser.emailAddress.$error }]"
                type="email"
                placeholder="Email address of user"
                autocomplete="off"
                v-model.trim="$v.invitedUser.emailAddress.$model"
                class="bg-[#fcfcfd] border-[#d0d5dd] border-solid border p-[14px] rounded-[8px] w-full"
              />
              <div
                class="invalid-feedback"
                v-if="!$v.invitedUser.emailAddress.required"
              >
                Field is required.
              </div>
              <div
                class="invalid-feedback"
                v-if="!$v.invitedUser.emailAddress.email"
              >
                Email is invalid.
              </div>
            </div>
          </div>
          <div class="pb-[16px]">
            <label
              class="text=[#353535] font-bold-500 text-[14px] leading-[20px]"
              >Role</label
            >
            <div>
              <select
                :class="[{ 'is-invalid': $v.invitedUser.role.$error }]"
                placeholder="Select an option"
                v-model.trim="$v.invitedUser.role.$model"
                class="border border-[#D0D5DD] px-[14px] py-[12px] rounded-[8px] w-full text-[#96A0B5] outline-none custom-select custom-select-lg"
              >
                <option v-for="r in roles" :key="r.id" :value="r.id">
                  {{ r.text }}
                </option>
              </select>
              <div
                class="invalid-feedback"
                v-if="!$v.invitedUser.role.required"
              >
                Field is required.
              </div>
            </div>
          </div>
          <div class="pb-[16px]">
            <label
              class="text=[#353535] font-bold-500 text-[14px] leading-[20px]"
              >Staff Id</label
            >
            <div>
              <input
                class="bg-[#fcfcfd] border-[#d0d5dd] border-solid border p-[14px] rounded-[8px] w-full"
                type="text"
                placeholder="Staff Id of user"
                v-model="invitedUser.staffId"
              />
            </div>
          </div>
        </div>
        <div class="flex items-center gap-[8px]">
          <button
            class="bg-[#fcfcfd] border-[##96a0b5] border-solid border py-[16px] px-[24px] rounded-[8px] text-[16px] font-medium leading-[20px] w-full disabled:cursor-not-allowed"
            type="button"
            data-dismiss="modal"
            :disabled="isInviting"
          >
            Cancel
          </button>
          <button
            :disabled="isInviting"
            class="bg-[#2463eb] border-[##2463eb] border-solid border py-[16px] px-[24px] rounded-[8px] text-white text-[16px] font-medium leading-[20px] w-full disabled:cursor-not-allowed"
            type="button"
            @click.prevent="invite"
          >
            {{ isInviting ? "Loading" : "Invite User" }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { required, email } from "vuelidate/lib/validators";
import { bus } from "../../main";
export default {
  name: "InviteSalesUser",
  props: ["count"],
  data() {
    return {
      isInviting: false,
      roles: [],
      invitedUser: {
        phoneNumber: "",
        emailAddress: "",
        lastname: "",
        othernames: "",
        role: "",
        staffId: "",
      },
    };
  },
  created() {
    bus.$on("getroles", this.getRoles);
    bus.$on("getroles", () => {});
  },
  computed: {
    user: function() {
      return this.$store.state.currentUser;
    },
    checkModal() {
      this.getRoles();
      return this.count;
    },
  },

  validations: {
    invitedUser: {
      emailAddress: { required, email },
      role: { required },
    },
  },
  mounted() {
    this.getRoles();
  },
  methods: {
    async getRoles() {
      this.role = [];
      try {
        const res = await this.$http.get("/Roles/getAllEnterpriseRoles");
        if (res) {
          const data = await res.json();
          this.roles = data
            .filter((v) => v.roleType === "SalesForce")
            .map((v) => ({
              id: v.id,
              text: v.roleName,
            }));
        }
      } catch (error) {}
    },
    async invite() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        this.isInviting = true;

        let data = {
          phoneNumber: this.invitedUser.phoneNumber,
          emailAddress: this.invitedUser.emailAddress,
          lastName: this.invitedUser.lastName,
          otherNames: this.invitedUser.otherNames,
          roleId: this.invitedUser.role,
          parentId: this.user.parentId,
          staffId: this.invitedUser.staffId,
        };

        try {
          const response = await this.$http.post("/SalesUsers/invite", data);
          if (response.ok) {
            this.$toast.success("User invited successfully.", {
              icon: true,
              rtl: false,
            });
            this.$emit("onInviteComplete");
          }
        } catch (error) {}
        this.isInviting = false;
      }
    },
  },
  beforeDestroy() {
    bus.$off("getroles", this.getRoles);
  },
};
</script>

<style></style>
